import { Injectable, signal, computed, effect, Injector } from '@angular/core';
import { DirectApiService } from './directApi.service';
import {lastValueFrom } from 'rxjs';

import { DirectSessionLogicService } from './direct-session-logic.service';
import { Plan, FeatureData } from './models/plan.model';
import { StepService } from './step.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PlanService {
  
  PlanFetchLockout: boolean = false;
  private _planView = signal<Plan[]>([]);
  public planViewSignal = computed(() => this._planView())
  get planViewSignalValue(): Plan[] {
    if(this._planView().length === 0 && !this.PlanFetchLockout){
      this.getPlans();
      this.PlanFetchLockout = true;
    }
    return this._planView();
  }
  public SetPlanView(plans: Plan[]) {
    this._planView.set(plans);
  }

  FeatureFetchLockout: boolean = false;
  private _featureView = signal<FeatureData[]>([]);
  public featureViewSignal = computed(() => this._featureView())
  get featureViewSignalValue(): FeatureData[] {
    if(this._featureView().length === 0 && !this.FeatureFetchLockout){
      this.getPlanFeatures();
    }
    return this._featureView();
  }
  public SetFeatureView(features: FeatureData[]) {
    this._featureView.set(features);
  }

  planSelectionLockout: boolean = false;
  private _planSelectionFromUrl = signal<string | null>(null);
  public planSelectionFromUrl = computed(() => this._planSelectionFromUrl());
  public SetPlanSelectionFromUrl(planId: string) {
    this._planSelectionFromUrl.set(planId);
  }


  constructor(
    public directApiService: DirectApiService,
    public stepService: StepService,
    public router: Router,
    private injector: Injector,
  ) {

    effect(() => {
      const dsl = this.injector.get(DirectSessionLogicService);
      if(this.planSelectionFromUrl() !== null
      && dsl.planSelectedSignal() === undefined
      && this.planViewSignal().length > 0
      && !this.planSelectionLockout){

        this.selectPlan();
      }
    });
  }


  async getPlans() {
    console.log("Getting plans");

    while(this.planViewSignal().length == 0){
      if(this.planViewSignal().length == 0 && !this.PlanFetchLockout){
        this.PlanFetchLockout = true;
        await this.initPlans();

      }else{
        console.log("Plans already loaded", this.planViewSignal());
      }

      await new Promise(resolve => setTimeout(resolve, 200)); //wait 200ms and try again
    }
  }

  async initPlans() {
    try{
      const response = await lastValueFrom( await this.directApiService.fetchPlans() );
      this.SetPlanView(response);
    }
    catch(e) {
      console.error("Error fetching plans: ", e);
      this.SetPlanView([]);
    }
  }

  selectPlan() {
    const dsl = this.injector.get(DirectSessionLogicService);
    let planId = this.planSelectionFromUrl;
    if (planId()) {
      const plan = this.planViewSignal().find(plan => plan.urlExtension === planId());
      if (plan != undefined) {
        dsl.setCustomerPlan(plan);
        this.planSelectionLockout = true;
      }
    }
  }





  async getPlanFeatures() {  
    if(this.featureViewSignal.length == 0){
      await this.initFeatures();
    }

    while(this.featureViewSignal.length == 0){
      await new Promise(resolve => setTimeout(resolve, 100)); //wait 100ms and try again
    }
  }

  async initFeatures(){
    try{
      const response = await lastValueFrom( await this.directApiService.fetchFeatures() );
      this.SetFeatureView( response );

    }catch (e){
      console.error("Error fetching features: ", e);
      this.SetFeatureView([]);
    }
  }

  
}